import { State } from './typings'

export const initialState: State = {
  externalLocations: [],
  matches: new Map(),
  saving: false,
}
